import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { filterGroupAssignColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getTmobilejFilterGroupAssignList } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "msisdn",
  "subscriber_id",
  "filter_type",
  "selected_group_names",
  "selected_group_ids",
  "status",
  "batch_id",
  "created_at",
  "last_updated",
];

const TmobilejFilterGroupAssignBatch = () => (
  <BatchDetail
    title="Bulk Assign Filter Groups"
    apiGet={__getTmobilejFilterGroupAssignList}
    client={CLIENTS.tmobilej}
    columnsFactory={filterGroupAssignColumns}
    copyKeys={COPY_KEYS}
    getRowPath={(row) => `/tmobilej/filter_group_assign/${row.id}`}
  />
);

export default TmobilejFilterGroupAssignBatch;
